"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addImageGroup = exports.getImageGroupKeyValues = exports.getImageGroup = exports.collection = void 0;
const date_fns_1 = require("date-fns");
const app_1 = __importDefault(require("firebase/compat/app"));
require("firebase/compat/firestore");
__exportStar(require("@ht-lib/accounts-models/lib/imageGroups"), exports);
let _coll = null;
function collection() {
    if (_coll === null) {
        _coll = app_1.default.firestore().collection('imageGroups');
    }
    return _coll;
}
exports.collection = collection;
async function getImageGroup(key, value) {
    const snap = await collection().where(`keys.${key}`, '==', value).get();
    if (!snap.size)
        return null;
    return snap.docs[0];
}
exports.getImageGroup = getImageGroup;
async function getImageGroupKeyValues(keyValues) {
    const keys = Object.keys(keyValues);
    if (keys.length === 0) {
        throw Error('Cannot getImageGroupKeyValues with no keys present');
    }
    let query = collection();
    keys.forEach(key => {
        query = query.where(`keys.${key}`, '==', keyValues[key]);
    });
    const snap = await query.get();
    if (snap.size === 0)
        return null;
    return snap.docs[0];
}
exports.getImageGroupKeyValues = getImageGroupKeyValues;
async function addImageGroup(imageGroup) {
    const badValues = Object.entries(imageGroup).map(([key, value]) => {
        if (value === undefined) {
            console.error('Found undefined value when adding image group. Value Key: ', key);
            return true;
        }
        return false;
    });
    if (badValues.some(Boolean)) {
        return;
    }
    const existingGroups = await getImageGroupKeyValues(imageGroup.keys);
    const update = {
        ...imageGroup,
        createdUnixTime: (0, date_fns_1.getUnixTime)(new Date())
    };
    if (existingGroups != null) {
        return existingGroups.ref.set(update);
    }
    else {
        return collection().doc().set(update);
    }
}
exports.addImageGroup = addImageGroup;
